import React, { PureComponent } from 'react'
import {
  TableWrapper,
  StyledTable,
  TableHeader,
  TableHead,
  TableRow,
  TableBody,
  PaginationWrapper,
} from './styledComponents';
import RowItem from './RowItem'
import { compare } from 'utils/helpers';
import Icon from '../Icon';
import Loader from 'components/Loader';
import { colors } from 'globalStyles';

const Pagination = ({ pageList, currentPage, pageCount, onPageChange }) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === pageCount;

  return (
    pageList
      ? <PaginationWrapper>
        <div
          className={`first-btn ${isFirstPage ? 'disabled' : ''}`}
          onClick={() => !isFirstPage && onPageChange(1)}>
          First
        </div>
        <div
          className={`prev ${isFirstPage ? 'disabled' : ''}`}
          onClick={() => !isFirstPage && onPageChange(currentPage - 2 > 1 ? currentPage - 2 : 1)} >
          <Icon name='drop-down' size='12' />
        </div>
        {pageList.map((item, idx) => (
          <div
            key={idx}
            className={`page-btn ${item.value === currentPage ? 'selected' : ''}`}
            onClick={() => onPageChange(item.value)}>
            {item.label}
          </div>
        ))}
        <div
          className={`next ${isLastPage ? 'disabled' : ''}`}
          onClick={() => !isLastPage && onPageChange(currentPage + 2 > pageCount ? pageCount : currentPage + 2)}  >
          <Icon name='drop-down' size='12' />
        </div>
        <div
          className={`last-btn ${isLastPage ? 'disabled' : ''}`}
          onClick={() => !isLastPage && onPageChange(pageCount)}>
          Last
        </div>
      </PaginationWrapper>
      : null
  )
}

export default class Table extends PureComponent {
  state = {
    sort: null
  }

  handleSort(name, noSort) {
    const { sort } = this.state;
    if (!noSort) {
      const sortObj = { path: name, isDesc: !sort || sort.path !== name ? false : !sort.isDesc };
      this.setState({ sort: sortObj }, () => {
        const { sortChanged } = this.props;
        if (sortChanged) sortChanged(sortObj);
      })
    }
  }

  getData = () => {
    var data = this.props.data && Array.isArray(this.props.data) ? this.props.data : [];

    return data;
  }

  generatePaginationList = () => {
    const { currentPage, pageCount } = this.props;
    var result = [];
    if (pageCount - currentPage < 5) {
      while (pageCount - result.length >= 1 && result.length <= 5) {
        const pageValue = pageCount - result.length;
        result.unshift({ label: pageValue, value: pageValue });
      }

    } else {
      result = [
        { label: currentPage, value: currentPage },
        { label: currentPage + 1, value: currentPage + 1 },
        { label: '...', value: currentPage + 2 },
        { label: pageCount - 1, value: pageCount - 1 },
        { label: pageCount, value: pageCount }
      ]
    }

    return result;
  }

  render() {
    const { columns, currentPage, pageCount, onPageChange, isFetching, isLeadsTable } = this.props;
    const { sort } = this.state;
    var data = this.getData();
    if (!columns) return;

    return (
      <TableWrapper className="table-wrapper" isLeadsTable={isLeadsTable}>
        <StyledTable>
          <TableHead>
            <TableRow>
              {columns.map((c, idx) => {
                const isSort = sort && sort.path === c.path;
                return (
                  <TableHeader
                    key={idx}
                    onClick={() => this.handleSort(c.path, c.noSort)}
                  >
                    <div className={isSort ? "sorted" : ""}>
                      {c.headerCustom
                        ? c.headerCustom(this.handleSort)
                        : c.header}
                      {isSort && (
                        <Icon
                          name="drop-down"
                          size="10"
                          className={sort.isDesc ? "sort-desc-icon" : ""}
                        />
                      )}
                    </div>
                  </TableHeader>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {isFetching ? (
              <tr className="loader">
                <td colSpan={10}>
                  <Loader color={colors.MAIN_COLOR} size="large" />
                </td>
              </tr>
            ) : (
              data.map((r, idx) => (
                <RowItem
                  key={idx}
                  columns={columns}
                  data={r}
                  isEven={idx % 2 === 0}
                  isLeadsTable={isLeadsTable}
                />
              ))
            )}
          </TableBody>
        </StyledTable>
        {currentPage && pageCount && onPageChange && pageCount !== 1 && (
          <Pagination
            pageList={this.generatePaginationList()}
            currentPage={currentPage}
            pageCount={pageCount}
            onPageChange={onPageChange}
          />
        )}
      </TableWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Table/index.js